export default "__VITE_ASSET__DNFBKPO5__"